<footer class="portal-footer bg-primary text-white py-3">
  <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
    <span>&copy; 2026 Portal. Todos los derechos reservados.</span>
    <nav aria-label="Enlaces del pie de página">
      <a class="link-light text-decoration-none" href="#">Términos y condiciones</a>
      <span class="mx-2">|</span>
      <a class="link-light text-decoration-none" href="#">Política de privacidad</a>
    </nav>
  </div>
</footer>
